import { render, staticRenderFns } from "./RefuseConNew.vue?vue&type=template&id=2173bcab&"
import script from "./RefuseConNew.vue?vue&type=script&lang=js&"
export * from "./RefuseConNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports